import type { TotalContent } from '@/blocks/domain/types/BlockContent/TotalContent';
import { isTotalLineSource } from '@/blocks/domain/helpers/totalFields';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';

type TotalDto = Extract<BlockContentDto, { kind: 'total' }>;

export function mapTotalContent(dto: TotalDto): TotalContent {
  const content: TotalContent = {
    kind: 'total',
    showSubtotal: dto.show_subtotal,
    showAdjustments: dto.show_adjustments,
    grandTotalLabel: dto.grand_total_label
  };
  if (dto.placement === 'left' || dto.placement === 'right') content.placement = dto.placement;
  if (dto.heading) content.heading = dto.heading;
  if (dto.subtotal_label) content.subtotalLabel = dto.subtotal_label;
  if (dto.discount_label) content.discountLabel = dto.discount_label;
  if (dto.surcharge_label) content.surchargeLabel = dto.surcharge_label;
  if (dto.tax_label) content.taxLabel = dto.tax_label;
  if (dto.row_order?.length) {
    const sources = dto.row_order.filter(isTotalLineSource);
    if (sources.length > 0) content.rowOrder = sources;
  }
  return content;
}

export function fromTotalContent(content: TotalContent): TotalDto {
  const dto: TotalDto = {
    kind: 'total',
    show_subtotal: content.showSubtotal,
    show_adjustments: content.showAdjustments,
    grand_total_label: content.grandTotalLabel
  };
  if (content.placement) dto.placement = content.placement;
  if (content.heading) dto.heading = content.heading;
  if (content.subtotalLabel) dto.subtotal_label = content.subtotalLabel;
  if (content.discountLabel) dto.discount_label = content.discountLabel;
  if (content.surchargeLabel) dto.surcharge_label = content.surchargeLabel;
  if (content.taxLabel) dto.tax_label = content.taxLabel;
  if (content.rowOrder && content.rowOrder.length > 0) dto.row_order = content.rowOrder;
  return dto;
}
